var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTransfer = function SvgTransfer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.507,
    height: 27.598,
    viewBox: "0 0 33.507 27.598",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_transfer_691474_000000",
    d: "M48.53,26a1.986,1.986,0,0,0-1.078.4,1.952,1.952,0,0,0-.4,2.741l3.542,4.743H24.971a1.971,1.971,0,1,0,0,3.942H54.535a1.97,1.97,0,0,0,1.971-1.971,2.428,2.428,0,0,0-.585-1.386l-5.7-7.668A2.01,2.01,0,0,0,48.53,26ZM24.971,41.768A1.97,1.97,0,0,0,23,43.739a2.428,2.428,0,0,0,.585,1.386l5.7,7.668a2.01,2.01,0,0,0,1.694.8,1.986,1.986,0,0,0,1.078-.4,1.952,1.952,0,0,0,.4-2.741L28.913,45.71H54.535a1.971,1.971,0,1,0,0-3.942Z",
    transform: "translate(-23 -25.998)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransfer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transfer.39dae884.svg";
export { ForwardRef as ReactComponent };